import { render, staticRenderFns } from "./Group.vue?vue&type=template&id=a548d260&scoped=true"
var script = {}
import style0 from "./Group.vue?vue&type=style&index=0&id=a548d260&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a548d260",
  null
  
)

export default component.exports